export default __webpack_public_path__ + "static/media/4-season.d347b407.png";